import {emptyValidator, formValidator} from "../../validators";

const schedulerMonthlyValidationState = {
    rscFrom:{
        validators : [emptyValidator()],
        name: "From Date",
    },
    rscTo:{
        validators : [emptyValidator()],
        name: "To Date",
    },
    rscFrequency:{
        validators : [emptyValidator()],
        name: "Frequency",
    },
    rscUom:{
        validators : [emptyValidator()],
        name: "UOM",
    },
    rscStatus:{
        validators : [emptyValidator()],
        name: "Status",
    },
    rscActive:{
        validators : [emptyValidator()],
        name: "Status",
    },


}
export const schedulerMonthlyValidation = (requestScheduler) => {
    return formValidator(requestScheduler, schedulerMonthlyValidationState);
};

const schedulerOneDayValidationState = {
    rscFrom:{
        validators : [emptyValidator()],
        name: "From Date",
    },

    rscFrequency:{
        validators : [emptyValidator()],
        name: "Frequency",
    },
    rscStatus:{
        validators : [emptyValidator()],
        name: "Status",
    },
    rscActive:{
        validators : [emptyValidator()],
        name: "Status",
    },


}
export const schedulerOneDayValidation = (requestScheduler) => {
    return formValidator(requestScheduler, schedulerOneDayValidationState);
};

const schedulerValidationState = {
    rscFrom:{
        validators : [emptyValidator()],
        name: "From Date",
    },
    rscTo:{
        validators : [emptyValidator()],
        name: "To Date",
    },
    rscFrequency:{
        validators : [emptyValidator()],
        name: "Frequency",
    },
    // rscUom:{
    //     validators : [emptyValidator()],
    //     name: "UOM",
    // },
    rscStatus:{
        validators : [emptyValidator()],
        name: "Status",
    },
    rscActive:{
        validators : [emptyValidator()],
        name: "Status",
    },


}
export const schedulerValidation = (requestScheduler) => {
    return formValidator(requestScheduler, schedulerValidationState);
};
